export const PetType = {
  Dog: 'dog',
  Cat: 'cat',
} as const;

export type PetType = (typeof PetType)[keyof typeof PetType];
